import React from 'react';
import { bool, shape, string } from 'prop-types';

import { Button } from '@andes/button';

const namespace = 'ui-search-fullsnackbar';

/**
 * ActionButtonSection component
 *
 * @component
 * @param {Object} props - Component props
 * @param {boolean} props.showShimmerAction - Controls whether the button should be shown
 * @param {Object} props.action_button - Button configuration
 * @param {string} props.action_button.text - Text to display on the button
 * @param {string} props.action_button.permalink - URL to navigate to when button is clicked
 * @returns {React.ReactElement|null} The button component or null if showShimmerAction is false
 */

const ActionButtonSection = ({ showShimmerAction, action_button }) => {
  if (!showShimmerAction) {
    return null;
  }

  return (
    <div className={`${namespace}__button-container`}>
      <Button className={`${namespace}__action-button`} size="medium" href={action_button?.permalink} type="button">
        {action_button?.text}
      </Button>
    </div>
  );
};

ActionButtonSection.propTypes = {
  action_button: shape({
    text: string,
    permalink: string,
  }),
  showShimmerAction: bool,
};

export default ActionButtonSection;
